module.exports = __webpack_public_path__ + "media/images/flags/32/Micronesia-7dff788b941d2c2cf13bb3ddae08bd07.png";